(function () {
  var CART_ADD = /\/cart\/add/;
  var CART_WRITE = /\/cart\/(add|update|change)/;
  var POLL_MS = 80;
  var QUIET_POLLS = 3;
  var MAX_WAIT_MS = 3000;
  var PENDING_CHECKOUT_KEY = 'july-razones-pending-checkout';

  var originalFetch = typeof window.fetch === 'function' ? window.fetch.bind(window) : null;
  var pending = 0;
  var redirecting = false;
  var clearPromise = null;
  var checkoutBusy = false;
  var upcartGuardInstalled = false;
  var activeAtcButton = null;
  var atcLoadingStylesReady = false;

  function ensureAtcLoadingStyles() {
    if (atcLoadingStylesReady) return;
    atcLoadingStylesReady = true;
    var style = document.createElement('style');
    style.id = 'july-atc-loading-style';
    style.textContent =
      'button.july-atc-loading,.kaching-bundles-block button.july-atc-loading{' +
      'position:relative;cursor:wait!important;pointer-events:none!important}' +
      'button.july-atc-loading .button__loader,' +
      'button.july-atc-loading > .button__loader{' +
      'display:none!important;visibility:hidden!important;opacity:0!important}' +
      'button.july-atc-loading::after,.kaching-bundles-block button.july-atc-loading::after{' +
      'content:"";position:absolute;left:50%;top:50%;width:22px;height:22px;margin:-11px 0 0 -11px;' +
      'border:2px solid currentColor;border-right-color:transparent;border-radius:50%;' +
      'opacity:.9;animation:july-atc-spin .65s linear infinite;z-index:2}' +
      'button.july-atc-loading:not(.kaching-bundles__cta)::before,.kaching-bundles-block button.july-atc-loading::before{' +
      'content:"";position:absolute;inset:0;border-radius:inherit;background:inherit;opacity:.55;z-index:0}' +
      '.kaching-bundles-block button.july-atc-loading [class*="loader"],' +
      '.kaching-bundles-block button.july-atc-loading [class*="Loader"],' +
      '.kaching-bundles-block button.july-atc-loading [class*="loading"],' +
      '.kaching-bundles-block button.july-atc-loading [class*="Loading"]{' +
      'display:none!important;visibility:hidden!important;opacity:0!important}' +
      '@keyframes july-atc-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){button.july-atc-loading::after{animation-duration:1.2s}}';
    document.head.appendChild(style);
  }

  function findAtcButton() {
    return document.querySelector(
      '.shopify-section--featured-product .buy-buttons button[type="submit"],' +
        ' kaching-bundles-block button[type="submit"],' +
        ' kaching-bundles-block .kaching-bundles__cta button,' +
        ' kaching-bundles-block button.kaching-bundles__cta'
    );
  }

  function setAtcLoading(button, loading) {
    if (!button) return;
    if (loading) {
      ensureAtcLoadingStyles();
      button.classList.add('july-atc-loading');
    } else {
      button.classList.remove('july-atc-loading');
    }
  }

  function resetAllAtcButtons() {
    var stuckSelector =
      'kaching-bundles-block button.july-atc-loading,' +
      'kaching-bundles-block button[aria-busy="true"],' +
      '.shopify-section--featured-product .buy-buttons button.july-atc-loading,' +
      '.shopify-section--featured-product .buy-buttons button[aria-busy="true"]';
    document.querySelectorAll(stuckSelector).forEach(function (btn) {
      btn.classList.remove('july-atc-loading');
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  }

  function resetCheckoutFlowState() {
    redirecting = false;
    checkoutBusy = false;
    pending = 0;
    clearPromise = null;
    activeAtcButton = null;
    resetAllAtcButtons();
    releaseCheckoutBusy();
  }

  function handleReturnFromCheckout() {
    try {
      if (!sessionStorage.getItem(PENDING_CHECKOUT_KEY)) return;
      sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
    } catch (e) {
      return;
    }
    clearCartRequest();
    resetCheckoutFlowState();
  }

  function beginCheckoutFlow(button) {
    activeAtcButton = button || activeAtcButton || findAtcButton();
    engageCheckoutBusy();
    setAtcLoading(activeAtcButton, true);
  }

  function closeUpcartDrawer() {
    if (typeof window.upcartCloseCart !== 'function') return;
    try {
      window.upcartCloseCart();
    } catch (e) {}
  }

  function suppressThemeDrawers() {
    document.querySelectorAll('cart-drawer, cart-notification-drawer, quick-buy-drawer').forEach(function (el) {
      if (typeof el.hide === 'function') {
        try {
          el.hide();
        } catch (e) {}
      }
      el.removeAttribute('open');
    });
  }

  function suppressCartDrawers() {
    closeUpcartDrawer();
    suppressThemeDrawers();
  }

  /** This landing never uses the UpCart drawer — only checkout. */
  function installUpcartGuard() {
    if (upcartGuardInstalled) return;
    if (typeof window.upcartSubscribeAddedToCart !== 'function') {
      setTimeout(installUpcartGuard, 100);
      return;
    }
    upcartGuardInstalled = true;

    if (typeof window.upcartOpenCart === 'function' && !window.upcartOpenCart.__julyLandingDisabled) {
      window.upcartOpenCart = function () {};
      window.upcartOpenCart.__julyLandingDisabled = true;
    }

    window.upcartSubscribeAddedToCart(function () {
      closeUpcartDrawer();
    });

    if (typeof window.upcartSubscribeCartOpened === 'function') {
      window.upcartSubscribeCartOpened(function () {
        closeUpcartDrawer();
      });
    }
  }

  function engageCheckoutBusy() {
    checkoutBusy = true;
    installUpcartGuard();
    suppressCartDrawers();
  }

  function releaseCheckoutBusy() {
    checkoutBusy = false;
  }

  function onFlowFailed() {
    if (redirecting) return;
    releaseCheckoutBusy();
    setAtcLoading(activeAtcButton, false);
    activeAtcButton = null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest(
        'kaching-bundles-block button, kaching-bundles-block [type="submit"], .shopify-section--featured-product .buy-buttons button[type="submit"]'
      );
      if (trigger) beginCheckoutFlow(trigger);
    },
    true
  );

  document.addEventListener(
    'variant:add',
    function (event) {
      if (event.detail) event.detail.blockCartDrawerOpening = true;
      beginCheckoutFlow(activeAtcButton);
      suppressCartDrawers();
    },
    true
  );

  document.addEventListener(
    'cart:change',
    function (event) {
      if (!checkoutBusy || !event.detail) return;
      event.detail.blockCartDrawerOpening = true;
      suppressCartDrawers();
    },
    true
  );

  installUpcartGuard();

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function release() {
    pending = Math.max(0, pending - 1);
  }

  function clearCartRequest() {
    if (!originalFetch) return Promise.resolve();
    return originalFetch(route('cart/clear.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })['catch'](function () {});
  }

  function markPendingCheckout() {
    try {
      sessionStorage.setItem(PENDING_CHECKOUT_KEY, '1');
    } catch (e) {}
  }

  try {
    handleReturnFromCheckout();
  } catch (e) {}

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resetCheckoutFlowState();
      handleReturnFromCheckout();
      return;
    }
    handleReturnFromCheckout();
  });

  function clearCartOnce() {
    if (clearPromise) return clearPromise;
    clearPromise = clearCartRequest();
    return clearPromise;
  }

  function onAddSettled(response) {
    release();
    if (response && response.ok === false) {
      onFlowFailed();
      return;
    }
    scheduleRedirect();
  }

  if (originalFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var args = arguments;

      if (CART_ADD.test(url)) {
        beginCheckoutFlow(activeAtcButton);

        var chained = clearCartOnce().then(function () {
          return originalFetch.apply(null, args);
        });

        pending++;
        chained.then(onAddSettled, function () {
          release();
          onFlowFailed();
        });

        return chained;
      }

      var result = originalFetch.apply(null, args);

      if (CART_WRITE.test(url) && result && typeof result.then === 'function') {
        pending++;
        result.then(release, release);
      }

      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__julyCartWrite = typeof url === 'string' && CART_WRITE.test(url);
    this.__julyCartAdd = typeof url === 'string' && CART_ADD.test(url);
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__julyCartWrite) {
      if (this.__julyCartAdd) beginCheckoutFlow(activeAtcButton);

      pending++;
      var xhr = this;
      var settled = false;

      xhr.addEventListener('loadend', function () {
        if (settled) return;
        settled = true;
        release();
        if (!xhr.__julyCartAdd) return;
        if (xhr.status >= 200 && xhr.status < 300) scheduleRedirect();
        else onFlowFailed();
      });
    }
    return originalSend.apply(this, arguments);
  };

  function goToCheckout() {
    markPendingCheckout();
    window.location.href = route('checkout');
  }

  function scheduleRedirect() {
    if (redirecting) return;
    redirecting = true;

    var waited = 0;
    var quiet = 0;

    (function wait() {
      closeUpcartDrawer();
      quiet = pending === 0 ? quiet + 1 : 0;

      if (quiet >= QUIET_POLLS || waited >= MAX_WAIT_MS) {
        goToCheckout();
        return;
      }

      waited += POLL_MS;
      setTimeout(wait, POLL_MS);
    })();
  }

  document.addEventListener('variant:add', function () {
    beginCheckoutFlow(activeAtcButton);
    setTimeout(scheduleRedirect, POLL_MS);
  });
})();
